// \src\pages\admin\login\page.tsx

import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface LoginResponse {
  success?: boolean;
  message?: string;
  user?: {
    id: number;
    username: string;
    name: string;
  };
}

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (loading) return;

    setError("");
    setLoading(true);

    try {
      const response = await fetch("/api/login.php", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          username,
          password,
        }),
      });

      const responseText = await response.text();

      let data: LoginResponse = {};

      try {
        data = JSON.parse(responseText);
      } catch {
        data = {};
      }

      if (response.ok && data.success === true) {
        navigate("/admin/dashboard", {
          replace: true,
        });

        return;
      }

      setError(
        data.message || "Usuário ou senha incorretos.",
      );
    } catch {
      setError(
        "Não foi possível conectar ao servidor. Tente novamente.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img
            src="/images/logo/logo.png"
            alt="M&Z"
            className="h-20 w-auto mx-auto mb-4 object-contain"
          />

          <h1 className="text-2xl font-heading font-bold text-foreground-950">
            Painel Administrativo
          </h1>

          <p className="text-foreground-500 text-sm mt-1">
            M&Z Materiais para Construção
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-background-50 border border-background-200 rounded-xl p-6 space-y-4"
        >
          <div>
            <label className="block text-xs font-label font-semibold text-foreground-700 mb-1 uppercase tracking-wider">
              Usuário
            </label>

            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2.5 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-950 font-label focus:outline-none focus:border-primary-400"
              placeholder="Digite o usuário"
              autoComplete="username"
              disabled={loading}
            />
          </div>

          <div>
            <label className="block text-xs font-label font-semibold text-foreground-700 mb-1 uppercase tracking-wider">
              Senha
            </label>

            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-950 font-label focus:outline-none focus:border-primary-400"
              placeholder="Digite a senha"
              autoComplete="current-password"
              disabled={loading}
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-xs font-label px-3 py-2 rounded-md">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !username || !password}
            className="w-full bg-primary-500 hover:bg-primary-600 disabled:bg-background-300 disabled:text-foreground-400 text-background-50 py-2.5 rounded-md font-label font-semibold text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>

        <p className="text-center text-foreground-400 text-xs mt-4">
          &copy; 2011–{new Date().getFullYear()} M&Z Materiais para Construção
        </p>
      </div>
    </div>
  );
}